/**
 * Authentication Modals
 * Handles login and register popup modals
 */

(function() {
    'use strict';

    // Track scroll position
    let savedScrollPosition = 0;

    // Modal management
    function openModal(modalId) {
        const modal = document.getElementById(modalId);
        if (!modal) return;

        // Save scroll position and lock body
        savedScrollPosition = window.scrollY;
        document.documentElement.style.setProperty('--scroll-position', `-${savedScrollPosition}px`);

        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('modal-open');

        // Focus first input
        setTimeout(() => {
            const firstInput = modal.querySelector('input:not([type="hidden"])');
            if (firstInput) firstInput.focus();
        }, 100);

        // Close on escape
        document.addEventListener('keydown', handleEscape);
    }

    function closeModal(modal) {
        if (typeof modal === 'string') {
            modal = document.getElementById(modal);
        }
        if (!modal) return;

        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('modal-open');
        document.documentElement.style.removeProperty('--scroll-position');

        // Restore scroll position
        window.scrollTo(0, savedScrollPosition);

        // Clear messages
        const messages = modal.querySelector('.ncaa-modal-messages');
        if (messages) messages.innerHTML = '';

        document.removeEventListener('keydown', handleEscape);
    }

    function closeAllModals() {
        document.querySelectorAll('.ncaa-modal[aria-hidden="false"]').forEach(closeModal);
    }

    function handleEscape(e) {
        if (e.key === 'Escape') {
            closeAllModals();
        }
    }

    function switchModal(fromModal, toModalId) {
        closeModal(fromModal);
        setTimeout(() => openModal(toModalId), 150);
    }

    function showMessage(modal, message, type) {
        const messagesEl = modal.querySelector('.ncaa-modal-messages');
        if (!messagesEl) return;

        messagesEl.innerHTML = '<div class="' + type + '">' + message + '</div>';
    }

    // Form handling
    function handleLoginSubmit(e) {
        e.preventDefault();

        const form = e.target;
        const modal = form.closest('.ncaa-modal');
        const submitBtn = form.querySelector('button[type="submit"]');
        const originalText = submitBtn.textContent;

        submitBtn.disabled = true;
        submitBtn.textContent = 'Signing in...';

        const formData = new FormData(form);
        formData.append('action', 'ncaa_ajax_login');

        fetch(ncaaAuth.ajaxUrl, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin'
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                showMessage(modal, 'Success! Redirecting...', 'success');
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            } else {
                showMessage(modal, data.data || 'Login failed. Please try again.', 'error');
                submitBtn.disabled = false;
                submitBtn.textContent = originalText;
            }
        })
        .catch(() => {
            showMessage(modal, 'An error occurred. Please try again.', 'error');
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
        });
    }

    function handleRegisterSubmit(e) {
        e.preventDefault();

        const form = e.target;
        const modal = form.closest('.ncaa-modal');
        const submitBtn = form.querySelector('button[type="submit"]');
        const originalText = submitBtn.textContent;

        // Client-side validation
        const password = form.querySelector('[name="ncaa_reg_password"]').value;
        const passwordConfirm = form.querySelector('[name="ncaa_reg_password_confirm"]').value;

        if (password !== passwordConfirm) {
            showMessage(modal, 'Passwords do not match.', 'error');
            return;
        }

        if (password.length < 8) {
            showMessage(modal, 'Password must be at least 8 characters.', 'error');
            return;
        }

        submitBtn.disabled = true;
        submitBtn.textContent = 'Creating account...';

        const formData = new FormData(form);
        formData.append('action', 'ncaa_ajax_register');

        fetch(ncaaAuth.ajaxUrl, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin'
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                showMessage(modal, 'Account created! Redirecting...', 'success');
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            } else {
                showMessage(modal, data.data || 'Registration failed. Please try again.', 'error');
                submitBtn.disabled = false;
                submitBtn.textContent = originalText;
            }
        })
        .catch(() => {
            showMessage(modal, 'An error occurred. Please try again.', 'error');
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
        });
    }

    // Initialize
    function init() {
        // Open modal triggers - support both data attribute and href
        document.addEventListener('click', function(e) {
            // Data attribute trigger
            const trigger = e.target.closest('[data-modal-open]');
            if (trigger) {
                e.preventDefault();
                openModal(trigger.getAttribute('data-modal-open'));
                return;
            }

            // Link with href to /login or /register
            const link = e.target.closest('a[href]');
            if (link) {
                const href = link.getAttribute('href');
                if (href && (href.endsWith('/login') || href.endsWith('/login/'))) {
                    e.preventDefault();
                    openModal('login-modal');
                    return;
                }
                if (href && (href.endsWith('/register') || href.endsWith('/register/'))) {
                    e.preventDefault();
                    openModal('register-modal');
                    return;
                }
            }

            // Close triggers
            const closeBtn = e.target.closest('[data-modal-close]');
            if (closeBtn) {
                e.preventDefault();
                closeModal(closeBtn.closest('.ncaa-modal'));
                return;
            }

            // Switch modal triggers
            const switchBtn = e.target.closest('[data-modal-switch]');
            if (switchBtn) {
                e.preventDefault();
                switchModal(switchBtn.closest('.ncaa-modal'), switchBtn.getAttribute('data-modal-switch'));
                return;
            }
        });

        // Form submissions
        const loginForm = document.getElementById('login-form');
        if (loginForm) {
            loginForm.addEventListener('submit', handleLoginSubmit);
        }

        const registerForm = document.getElementById('register-form');
        if (registerForm) {
            registerForm.addEventListener('submit', handleRegisterSubmit);
        }
    }

    // Run on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
